<div class="wccard p-3 mb-1">
    <app-companypage-ai [requestaidata]="titlesdataAI" [currentCompanyName]="currentCompanyName" [insightstabname]="'titles'" [totalcount]="totalTitleResultCount" [dataPending]="getDataPendingStatus()"></app-companypage-ai>
</div>
<div class="wccard p-3 mb-1">
    <p class="f-16 mb-6 font-weight-600" *ngIf="titles?.length && !showTitleLoader">What are the most common titles in {{currentCompanyName | titlecase}}?</p>
    <!-- <div class="mb-4">
        <select data-testid="auto-app-titles-tab-select-1" name="" class="newSelectInput" id="">
            <option value="0">Location</option>
            <option value="1">Location</option>
            <option value="2">Location</option>
        </select>
    </div> -->
    <div *ngIf="!titles?.length">
        <div class="loader text-center" *ngIf="showTitleLoader && !titleemptystate">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="titleemptystate && !showTitleLoader">
            <p class="text-center small p-5 text-484b59">No Data Available</p>
        </div>
    </div>

    <div class="mt-2" *ngIf="titlesdata?.data?.length">
        <table mat-table [dataSource]="titlesdata" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" matSort (matSortChange)="manualjobtitleSort()">

            <!-- key -->
            <ng-container matColumnDef="key">
                <th mat-header-cell mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by doc count" class="col-md-4">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['jobTitles']}}</p>
                </th>
                <td class="text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                    {{element.key | titlecase}}
                </td>
            </ng-container>

            <!-- doc_count -->
            <ng-container matColumnDef="doc_count">
                <th class="text-center col-md-2" mat-header-cell *matHeaderCellDef mat-sort-header="doc_count"
                    sortActionDescription="Sort by doc count">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['TalentCount']}} </p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600">
                    <span class="pointer" (click)="handelRedirection('jobtitle', element.key)">{{element.doc_count | number}}</span>
                </td>
            </ng-container>

            <!-- graph -->
            <ng-container matColumnDef="graph">
                <th class="text-center col-2" mat-header-cell *matHeaderCellDef mat-sort-header="graph"
                    sortActionDescription="Sort by percentage">
                    <p class="text-9696 f-12 m-0">{{tableHeaderObj['%OfTotal']}}</p>
                </th>
                <td class="" mat-cell *matCellDef="let element">
                    <div class="progress d-flex align-items-center" style="height: 12px!important;">
                        <span class="mr-1 text-484b59">
                            {{getTitlePercentage(element.doc_count)}}%
                        </span>
                        <span class="progress-bar" role="progressbar" style="background-color: #2E93A1 !important;" [ngStyle]="{'width.%': getTitlePercentage(element.doc_count)}" aria-valuenow="getTitlePercentage(element.doc_count)" aria-valuemin="0" aria-valuemax="100"></span>
                    </div>
                </td>
            </ng-container>
            <!--Avg Tenure-->
            <ng-container matColumnDef="avg_tenure">
                <th class="col-2" mat-header-cell *matHeaderCellDef mat-sort-header="avg_tenure"
                sortActionDescription="Sort by tenure">
                    <p class="text-9696 f-12 m-0"> {{tableHeaderObj['MedianTenure']}} <i class="far fa-info-circle text-9696 ml-1"  matTooltip="The median tenure is calculated based on the current tenure of each individual" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 f-12">
                    {{element.avg_tenure != 0 ? getFormattedTenure(element.avg_tenure): '0'}}
                </td>
            </ng-container>
       <ng-container matColumnDef="job_doc_count">
          <th class="" *matHeaderCellDef mat-header-cell>
            <p class="text-9696 f-12 m-0" [ngbTooltip]="jobdemand"
              >{{tableHeaderObj['JobDemand']}}</p>
              <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
          </th>
          <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
            <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <div *ngIf="!hasJobDemand">
            <span class="" *ngIf="element?.job_doc_count != 0" (click)="hasJobListingAccess &&  openJoblistSlider('jobtitles', element.key)" [class.pointer]="hasJobListingAccess">{{element.job_doc_count | number}}</span>

            <span class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>
            </div>
          </td>
        </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <!-- <div *ngIf="skills == null || skills.length == 0">
            <p class="text-center small p-5">No data to display</p>
        </div> -->
    </div>
</div>
<div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCountTitle > 10">
    <ngb-pagination [collectionSize]="totalCountTitle" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSizeTitle" rotate="false" (pageChange)="setPageTitles($event)" [(page)]="currentPageTitle" [ellipses]="false" [boundaryLinks]="false" [directionLinks]="false">
    </ngb-pagination>
</div>

<div class="wccard p-3 mt-2 mb-1">
    <p class="f-16 mb-6 font-weight-600">Which functions does this talent work in?</p>
    <div *ngIf="!functions?.length">
        <div class="loader text-center" *ngIf="!functionemptystate">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="functionemptystate">
            <p class="text-center small p-5 text-484b59">No Data Available</p>
        </div>
    </div>


    <div class="mt-2" *ngIf="functionsdata?.data?.length">
        <table mat-table [dataSource]="functionsdata" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" #functionsort="matSort" matSort (matSortChange)="manualfunctionsort()" >

            <!-- key -->
            <ng-container matColumnDef="key">
                <th mat-header-cell mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by doc count" class="col-md-4">
                    <p class="text-9696 f-12 m-0">Talent</p>
                </th>
                <td class="text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                    {{element.key | titlecase}}
                </td>
            </ng-container>

            <!-- doc_count -->
            <ng-container matColumnDef="doc_count">
                <th class="text-center col-md-2" mat-header-cell *matHeaderCellDef mat-sort-header="doc_count"
                    sortActionDescription="Sort by doc count">
                    <p class="text-9696 f-12 m-0">Talent Count</p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600">
                        <span class="pointer" (click)="handelRedirection('functions', element.key)">{{element.doc_count | number}}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="%total">
                <th class="text-center col-2" mat-header-cell *matHeaderCellDef mat-sort-header
                    sortActionDescription="Sort by doc count">
                    <p class="text-9696 f-12 m-0">% of Total</p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59">
                    {{getFunctionPercentage(element.doc_count) | number}}%
                </td>
            </ng-container>
                  <!--Avg Tenure-->
                  <ng-container matColumnDef="median_tenure">
                    <th class="col-2" mat-header-cell *matHeaderCellDef  mat-sort-header="median_tenure"
                    sortActionDescription="Sort by avg tenure">
                        <p class="text-9696 f-12 m-0">Median Tenure<i class="far fa-info-circle text-9696 ml-1"  matTooltip="The median tenure is calculated based on the current tenure of each individual" [matTooltipClass]="{ 'red-tooltip text-black': true }"></i></p>
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-484b59 f-12">
                        {{element.median_tenure != 0 ? getFormattedTenure(element.median_tenure): '0'}}
                    </td>
                </ng-container>
                              <ng-container matColumnDef="job_doc_count">
                <th class=""  *matHeaderCellDef mat-header-cell >
                    <p class="text-9696 f-12 m-0" [ngbTooltip]="jobdemand">Job Posts</p>
                           <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
                     <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    <div *ngIf="!hasJobDemand">
                      <span class="" *ngIf="element?.job_doc_count != 0" (click)="hasJobListingAccess && openJoblistSlider('functions', element.key)" [class.pointer]="hasJobListingAccess">{{element.job_doc_count | number}}</span>

                      <span class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>
                    </div>
                </td>
            </ng-container>



            <tr mat-header-row *matHeaderRowDef="displayedfunctionsColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedfunctionsColumns;"></tr>
        </table>
        <!-- <div *ngIf="skills == null || skills.length == 0">
            <p class="text-center small p-5">No data to display</p>
        </div> -->
    </div>
</div>

<div class="d-flex justify-content-center wccard ng-star-inserted" *ngIf="totalCountFunction > 5">
    <ngb-pagination [collectionSize]="totalCountFunction" [maxSize]="5" aria-label="Custom pagination" [pageSize]="pageSizeFunction" rotate="false" (pageChange)="setPageFunction($event)" [(page)]="currentPageFunction" [ellipses]="false" [boundaryLinks]="false"
    [directionLinks]="false">
    </ngb-pagination>
</div>

<div class="wccard p-3 mt-2 mb-1">
    <p class="f-16 mb-6 font-weight-600">Seniority</p>
    <div *ngIf="!seniority?.length">
        <div class="loader text-center" *ngIf="!seniorityEmptyState">
            <img src="../../assets/images/animation_lkl59h1l_small.gif" alt="loader" />
        </div>
        <div *ngIf="seniorityEmptyState">
            <p class="text-center small p-5 text-484b59">No Data Available</p>
        </div>
    </div>


    <div class="mt-2" *ngIf="senioritydata?.data?.length">
        <table mat-table [dataSource]="senioritydata" class="mat-elevation-z8" style="width: 100%; box-shadow: none;" #senioritySort="matSort" matSort (matSortChange)="manualSenioritySort()" >

            <!-- key -->
            <ng-container matColumnDef="key">
                <th mat-header-cell mat-header-cell *matHeaderCellDef
                    sortActionDescription="Sort by doc count" class="col-md-2">
                    <p class="text-9696 f-12 m-0">{{senioritytableHeaderObj['Title']}}</p>
                </th>
                <td class="text-484b59" mat-cell *matCellDef="let element" style="font-family: 'Poppins', sans-serif;">
                    {{element.key | titlecase}}
                </td>
            </ng-container>

            <!-- doc_count -->
            <ng-container matColumnDef="doc_count">
                <th class="text-center col-md-2" mat-header-cell *matHeaderCellDef mat-sort-header="doc_count"
                    sortActionDescription="Sort by doc count">
                    <p class="text-9696 f-12 m-0">{{senioritytableHeaderObj['TalentCount']}}</p>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600">
                        <span class="pointer" (click)="handelRedirection('functions', element.key)">{{element.doc_count | number}}</span>
                </td>
            </ng-container>


              <ng-container matColumnDef="job_doc_count">
                <th class="col-md-2"  *matHeaderCellDef mat-header-cell >
                    <p class="text-9696 f-12 m-0" [ngbTooltip]="jobdemand">{{senioritytableHeaderObj['JobDemand']}}</p>
                           <ng-template #jobdemand>
                      <p class="f-12 font-weight-600 mb-1">About Job Post Metrics</p>
                      <p class="f-12 mb-1">Job post data is sourced directly from company career pages and official employer sites, ensuring high accuracy and active demand.</p>
                      <p class="f-12">Job post and salary metrics are influenced by Job Titles, Skills, Location, Industry, Company, Seniority, and Function. Changes to other filters (e.g., education, gender, experience) do not impact these values.</p>
                    </ng-template>
                </th>
                <td mat-cell *matCellDef="let element" class="text-484b59 font-weight-600 f-12">
                     <div *ngIf="hasJobDemand" class="spinner-border position-absolute text-black"
                            role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    <div *ngIf="!hasJobDemand">
                      <span class=""  *ngIf="element?.job_doc_count != 0" (click)="hasJobListingAccess && openJoblistSlider('seniority', element.key)" [class.pointer]="hasJobListingAccess">{{element.job_doc_count | number}}</span>

                      <span class="" *ngIf="!element?.job_doc_count" style="font-family: Arial, sans-serif;">&mdash;</span>
                    </div>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedSeniorityColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedSeniorityColumns;"></tr>
        </table>
        <!-- <div *ngIf="skills == null || skills.length == 0">
            <p class="text-center small p-5">No data to display</p>
        </div> -->
    </div>
</div>


<app-insights-joblist [data]="toOpenSliderFromTabSubject.asObservable()" [events]="sendDataToSliderSubject.asObservable()"></app-insights-joblist>
